import { apiCMSWithToken } from './axios'

export const url = {
  postbook: '/postbook'
}

export async function bookingSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(`${url.postbook}?${params}`)
    return response
  } catch (error) {
    console.error('Error in bookingSearch:', error)
    throw error
  }
}

export async function bookingUpdateStatus(body) {
  const response = await apiCMSWithToken.post(url.postbook, body)
  return response
}
